<template>
  <v-container fluid>
    <v-row no-gutters class="mb-4">
      <v-col cols="12">
        <v-row justify="end">
          <v-btn class="mr-4" color="grey lighten-1" :to="{ name: 'ConstructionMasterDetail', params: { id: constructionId } }" depressed>戻る</v-btn>
        </v-row>
      </v-col>
    </v-row>
    <!-- メイン -->
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-row no-gutters>
            <v-col cols="12">
              <v-chip class="mr-2" color="accent" outlined label pill>
                <strong class="mr-2">工事原価</strong><v-icon small left>mdi-currency-jpy</v-icon>{{ totalBudgetPrice }}
              </v-chip>
              <v-divider/>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <!-- 工種選択 -->
            <v-col cols="12" md="3">
              <custom-tree-view :elevation="0" :title="treeTitle" :items="treeItems" @onSelected="onSelected" :visibleTemplate="false"
                :visibleFolderAdd="false" :visibleFileAdd="false" :visibleUnSelected="false" :visibleEdit="false" :visibleDelete="false" :visibleCopy="false" :visibleReflect="false"/>
            </v-col>
            <!-- 工種表示 -->
            <v-col cols="12" md="9">
              <custom-data-table :elevation="0" :tableName="tableName" :header="headers" :items="items" :loading="loading" :visibleStore="false">
                <template v-slot:custom>
                  <v-chip color="accent" outlined label pill>
                    <strong class="mr-2">選択工事原価</strong><v-icon small left>mdi-currency-jpy</v-icon>{{ budgetPrice }}
                  </v-chip>
                  <v-divider/>
                </template>
              </custom-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import BudgetApi from "@/api/budget-api"
  import CustomTreeView from '@/components/custom_ui/CustomTreeView';
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import CalcCommon from "@/helpers/calcCommon";

  export default {
    name: "WorkingBudgetInfo",
    components: {
      CustomTreeView,
      CustomDataTable
    },
    data: () => ({
      loading: false,
      // 金額系
      totalBudgetPrice: 0,
      budgetPrice: 0,
      // 工種選択
      treeTitle: "工種",
      treeItems: [],
      selectedNode: null,
      // 工種表示
      tableName: "選択項目",
      headers: [
          { text: "No.", value: "no" },
          { text: "費目", value: "expense" },
          { text: "規格等", value: "standard" },
          { text: "数量", value: "amount", align: 'end' },
          { text: "単位", value: "displayUnit" },
          // { text: "歩掛", value: "percentage" },
          { text: "数量×歩掛", value: "multipl", align: 'end' },
          { text: "単価", value: "unitPrice", align: 'end' },
          // { text: "消費税", value: "taxName" },
          { text: "金額(税抜)", value: "price", align: 'end' },
          // { text: "金額(税込)", value: "taxPrice" },
          { text: "集計費目", value: "aggregateName" }
      ],
      items: [],
      constructionId: null,
      budgetId: null,
      percentage_flg: true
    }),
    created() {
      this.initialize();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize() {
        this.isLoading();
        this.budgetApi = new BudgetApi();
        this.constructionId = this.$route.params.id
        this.budgetId = this.$route.params.budget
        const promise = this.budgetApi.info(this.constructionId, this.budgetId);
        promise.then(response => {
          this.percentage_flg = response.data.body.percentage_flg.percentage_flg;
          if (!this.percentage_flg) {
            this.headers = this.headers.filter(v => v.value !== "percentage");
            this.headers = this.headers.filter(v => v.value !== "multipl");
          }
          if (response.data.body.budget_info.tree_data) {
            this.treeItems = response.data.body.budget_info.tree_data.row;
            this.calcTotalPrice();
          }
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
      // 工種選択
      onSelected(node) {
        this.selectedNode = node
        this.tableName = node.data.text;
        this.items = node.data.items ? node.data.items : [];
        this.calcTotalPrice();
        for (var item of this.items) {
          item.unitPrice = CalcCommon.addFigure(item.unitPrice);
          item.taxPrice = CalcCommon.addFigure(item.taxPrice);
          item.price = CalcCommon.addFigure(item.price);
        }
      },
      // 工事原価・選択工事原価 計算
      calcTotalPrice() {
        // 工事原価
        if (this.treeItems) {
          this.totalBudgetPrice = 0;
          for (var item of this.treeItems) {
            this.totalBudgetPrice += this.reducePrice(item);
          }
          this.totalBudgetPrice = CalcCommon.addFigure(this.totalBudgetPrice);
        }
        // 選択工事原価
        if (this.selectedNode) {
          this.budgetPrice = this.reducePrice(this.selectedNode);
          this.budgetPrice = CalcCommon.addFigure(this.budgetPrice);
        } else {
          this.budgetPrice = 0;
        }
      },
      reducePrice(object) {
        var price = 0;
        if (object.children.length > 0) {
          for (var child of object.children) {
            price += this.reducePrice(child);
          }
        }
        if (object.data.items.length > 0) {
          // (数量 * 歩掛) * 単価
          for (var item of object.data.items) {
            var tmp = item.amount;
            if (this.percentage_flg) {
              // (数量 * 歩掛) 小数点以下第２位四捨五入
              tmp = item.multipl;
            }
            // (数量 * 歩掛) * 単価 小数点以下第1位切り上げ
            tmp = tmp * CalcCommon.disFigure(item.unitPrice);
            tmp = CalcCommon.orgCeil(tmp, 1);
            price += tmp;
          }
        }
        return price;
      }
    }
  }
</script>
